import { TextField } from '@mui/material';
import React from 'react'
import { toast } from 'react-toastify';

const index = (props: { register: any; handleSubmit: any; errors: any; formValue: any; setFormValue: any; handleNext: any; }) => {
  const onError = (data: any) => {
    toast.error(data[Object.keys(data)[0]].message, {
      theme: "colored",
    });
  };

  const onSubmit = (data: any) => {
    props.setFormValue({
      ...props.formValue,
      name: data.name,
      shortName: data.shortName,
    });

    props.handleNext();
  };

  return <form id="page1" onSubmit={props.handleSubmit(onSubmit, onError)}>
    <div className="grid grid-cols-2 gap-2">
      <div>
        <TextField size="small" fullWidth label="Name" name="name" {...props.register("name")} error={props.errors?.name ? true : false} />
        <p color="error" className="text-red-700 text-sm">{props.errors?.name?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth label="Short Name" name="shortName" {...props.register("shortName")} error={props.errors?.shortName ? true : false} />
        <p color="error" className="text-red-700 text-sm">{props.errors?.shortName?.message}</p>
      </div>
    </div>
  </form>;
}

export default index